import styled from "@emotion/styled";

import { theme } from "../../ThemeProvider/CandyTheme/ThemeShorthand";

export const ValueViewerValueContainer = styled.div(props => ({
    overflow: "auto",
    width: 500,
    marginLeft: theme(props)
        .reactUISizes.modal.leftPadding.map(x => -x)
        .css(),
    marginRight: theme(props)
        .reactUISizes.modal.rightPadding.map(x => -x)
        .css(),
    marginBottom: theme(props)
        .reactUISizes.modal.bottomPadding.map(x => -x)
        .css(),
    padding: 32,
}));
